import { useCallback } from 'react';
import styles from './RealizeLoader.module.scss';

const loaderHtml =
    '<dotlottie-player src="/resources/js/loader/lottie-loader" background="transparent" speed="1" style="width: 650px; height: 650px" loop autoplay></dotlottie-player>';

export const RealizeLoader = () => {
    const ref = useCallback(target => {
        if (target && !target.innerHTML) {
            target.innerHTML = loaderHtml;
        }
    }, []);

    return <div className={styles['container']} data-testid="realize-loader" ref={ref}></div>;
};
